<p-dialog
        [(visible)]="visible"
        [modal]="true"
        header="Select Details"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-table
                [value]="details"
                [(selection)]="selectedDetails"
                dataKey="id"
                selectionMode="multiple"
                scrollable="true"
                scrollHeight="300px"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Name</th>
                    <th>Is naming relevant</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detail>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="detail"></p-tableCheckbox>
                    </td>
                    <td>{{ detail.name }}</td>
                    <td>{{ detail.isNamingRelevant ? 'Yes' : 'No' }}</td>
                </tr>
            </ng-template>
        </p-table>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" (click)="close()" severity="secondary"></p-button>
            <p-button label="Assign" (click)="save()" [loading]="saving"></p-button>
        </div>
    </div>
</p-dialog>
